import { Check, X, Phone } from "lucide-react";
import logo from "@/assets/oz-move-logo.webp";

const rows = [
  {
    feature: "Transparent, upfront pricing",
    description: "Know exactly what you're paying before the job starts.",
  },
  {
    feature: "Same-day & next-day availability",
    description: "Need to move fast? We'll be there when you need us.",
  },
  {
    feature: "Real-time booking updates",
    description: "Live confirmations so you always know what's happening.",
  },
  {
    feature: "Fully insured coverage",
    description: "Every item protected from pickup to delivery.",
  },
  {
    feature: "No hidden fees, ever",
    description: "The price we quote is the price you pay. Guaranteed.",
  },
  {
    feature: "Dedicated support team",
    description: "A real person you can reach before, during, and after.",
  },
];

const ComparisonSection = () => (
  <section id="comparison" className="bg-[#f7f7f7] py-20 md:py-28">
    <div className="container max-w-4xl">
      <h2 className="text-3xl md:text-4xl font-black text-[#1a1a1a] text-center mb-14 leading-tight">
        Why More People Are Choosing
        <br />
        <span className="text-[#1a1a1a]">OZ MOVE CO</span>
      </h2>

      {/* Table header */}
      <div className="grid grid-cols-[1fr_110px_110px] md:grid-cols-[1fr_160px_140px] items-end gap-0 mb-0">
        <div />
        <div className="bg-[#FFC300] rounded-t-2xl py-4 text-center shadow-[0_-4px_16px_rgba(255,195,0,0.2)] flex flex-col items-center justify-center">
          <img src={logo} alt="OZ MOVE CO." className="h-14 md:h-16 w-auto" width="384" height="256" />
        </div>
        <div className="py-5 text-center">
          <span className="text-[#1a1a1a]/70 font-bold text-xs md:text-sm">
            Traditional
          </span>
        </div>
      </div>

      {/* Rows */}
      <div>
        {rows.map((row, i) => (
          <div
            key={row.feature}
            className="grid grid-cols-[1fr_110px_110px] md:grid-cols-[1fr_160px_140px] items-center gap-0 border-b border-[#1a1a1a]/8 last:border-b-0"
          >
            {/* Feature */}
            <div className="py-6 pr-4">
              <p className="font-extrabold text-[#1a1a1a] text-sm md:text-base leading-snug">
                {row.feature}
              </p>
              <p className="text-[#1a1a1a]/70 text-xs md:text-sm mt-1 leading-snug">
                {row.description}
              </p>
            </div>

            {/* OZ MOVE column - yellow */}
            <div
              className={`bg-[#FFC300] flex items-center justify-center py-6 shadow-[inset_0_0_0_1px_rgba(0,0,0,0.05)] ${
                i === rows.length - 1 ? "rounded-b-2xl shadow-[0_4px_16px_rgba(255,195,0,0.15),inset_0_0_0_1px_rgba(0,0,0,0.05)]" : ""
              }`}
            >
              <div className="w-8 h-8 rounded-full bg-[#1a1a1a]/10 flex items-center justify-center">
                <Check className="w-4 h-4 text-[#1a1a1a]" strokeWidth={3} />
              </div>
            </div>

            {/* Traditional column */}
            <div className="flex items-center justify-center py-6">
              <div className="w-8 h-8 rounded-full bg-[#1a1a1a]/[0.04] flex items-center justify-center">
                <X className="w-4 h-4 text-[#1a1a1a]/20" strokeWidth={2.5} />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* CTA block */}
      <div className="mt-16 text-center">
        <h3 className="text-2xl md:text-3xl font-black text-[#1a1a1a] mb-3">
          Ready to move the easy way?
        </h3>
        <p className="text-[#1a1a1a]/70 text-sm mb-8">
          Fast quotes and reliable scheduling.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#quote"
            className="bg-[#1a1a1a] text-[#FFC300] px-8 py-4 text-lg font-bold rounded-md hover:opacity-90 transition-opacity text-center"
          >
            Get Free Quote
          </a>
          <a
            href="tel:1800556654"
            className="flex items-center justify-center gap-2 border-2 border-[#1a1a1a] text-[#1a1a1a] px-8 py-4 text-lg font-bold rounded-md hover:bg-[#1a1a1a]/5 transition-colors text-center"
          >
            <Phone className="w-5 h-5" />
            Call Now
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default ComparisonSection;
